module.exports = __webpack_public_path__ + "static/media/octagon.4f6e37da.svg";